import React from "react";
import CIcon from "@coreui/icons-react";
import { freeSet } from "@coreui/icons";

const _nav = (role) => [
  {
    _tag: "CSidebarNavDropdown",
    name: "Dashboard",
    route: "/dashboard",
    icon: (
      <CIcon
        content={freeSet.cilSpeedometer}
        customClasses="c-sidebar-nav-icon"
      />
    ),
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "Total Issued Ticket Violations",
        to: "/dashboard/ticket-issued-violations",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Summary",
        to: "/dashboard",
      },
    ],
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "Booklet",
    route: "/booklet-receiving",
    icon: (
      <CIcon content={freeSet.cilBook} customClasses="c-sidebar-nav-icon" />
    ),
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "Receiving",
        to:
          role.toLowerCase() === "staff"
            ? "/booklet-receiving"
            : "/booklet-receiving/add",
        permission: "Permissions.BookletReceiving.View",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Issuance",
        to: "/booklet-allocation",
        permission: "Permissions.BookletAllocation.View",
      },
    ],
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "Ticket Encoding",
    route: "/ticket-encoding",
    icon: (
      <CIcon content={freeSet.cilList} customClasses="c-sidebar-nav-icon" />
    ),
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "City Ordinance: Encode Ticket",
        to: "/ticket-encoding/add?type=OVR",
        permission: "Permissions.TicketEncoding.Create",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Traffic: Encode Ticket",
        to: "/ticket-encoding/add?type=TRAFFIC",
        permission: "Permissions.TicketEncoding.Create",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Apprehension Heatmap",
        to: "/ticket-encoding/traffic-heatmap",
        permission: "Permissions.TicketEncoding.View",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Summary",
        to: "/ticket-encoding",
        permission: "Permissions.TicketEncoding.View",
      },
    ],
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "Assessment",
    route: "/assessment",
    icon: (
      <CIcon content={freeSet.cilShare} customClasses="c-sidebar-nav-icon" />
    ),
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "Assess Ticket",
        to: "/assessment/add",
        permission: "Permissions.TicketAssessment.Create",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Summary",
        to: "/assessment",
        permission: "Permissions.TicketAssessment.View",
      },
    ],
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "Payment",
    route: "/payment",
    icon: (
      <CIcon content={freeSet.cilMoney} customClasses="c-sidebar-nav-icon" />
    ),
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "Record Payment",
        to: "/payment/add",
        permission: "Permissions.TicketPayment.Create",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Sync OR Details",
        to: "/payment/sync",
        permission: "Permissions.TicketPayment.Create",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Summary",
        to: "/payment",
        permission: "Permissions.TicketPayment.View",
      },
    ],
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "Collection",
    route: "/collection",
    icon: (
      <CIcon content={freeSet.cilBarChart} customClasses="c-sidebar-nav-icon" />
    ),
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "Collection Summary",
        to: "/collection",
        permission: "Permissions.Collection.View",
      },
      // {
      //   _tag: "CSidebarNavItem",
      //   name: "Ticket Collection Summary",
      //   to: "/collection/ticket-collection",
      //   permission: "Permissions.Collection.View",
      // },
      // {
      //   _tag: "CSidebarNavItem",
      //   name: "OVR Ticket vs. Collection",
      //   to: "/collection/collection-vs-ticket",
      //   permission: "Permissions.CollectionVsTicket.View",
      // },
    ],
  },

  {
    _tag: "CSidebarNavDropdown",
    name: "Sync to LTO",
    route: "/sync-tickets",
    icon: (
      <CIcon content={freeSet.cilSync} customClasses="c-sidebar-nav-icon" />
    ),
    permission: "Permissions.LtoAccess.View",
    _children: [
      // nash aug 10, 2023 - new page here - sync dashboard
      {
        _tag: "CSidebarNavItem",
        name: "Sync Dashboard",
        to: "/lto-sync-dashboard",
        permission: "Permissions.LtoAccess.View",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Sync Tickets",
        to: "/sync-tickets",
        permission: "Permissions.LtoAccess.View",
      },
      {
        _tag: "CSidebarNavItem",
        name: "LTO Inquiry Form",
        to: "/inquiry",
        permission: "Permissions.LtoAccess.View",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Sync Ticket Logs",
        to: "/sync-ticket-logs",
        permission: "Permissions.LtoAccess.View",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Sync Payment Logs",
        to: "/sync-payment-logs",
        permission: "Permissions.LtoAccess.View",
      },
      {
        _tag: "CSidebarNavItem",
        name: "LTO Sync Settings",
        to: "/lto-sync-settings",
        permission: "Permissions.LtoAccess.View",
      },
    ],
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "Maintenance",
    route: "/maintenance",
    icon: (
      <CIcon content={freeSet.cilSettings} customClasses="c-sidebar-nav-icon" />
    ),
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "Agencies",
        to: "/maintenance/agency",
        permission: "Permissions.Area.View",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Deputized Officers",
        to: "/maintenance/enforcer",
        permission: "Permissions.Enforcer.View",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Holidays",
        to: "/maintenance/holiday",
        permission: "Permissions.Enforcer.View",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Suppliers",
        to: "/maintenance/supplier",
        permission: "Permissions.Supplier.View",
      },

      {
        _tag: "CSidebarNavItem",
        name: "Violations",
        to:
          role.toLowerCase() === "staff"
            ? "/maintenance/violation"
            : "/maintenance/violation/add",
        permission: "Permissions.Violation.View",
      },
    ],
  },
  {
    _tag: "CSidebarNavItem",
    name: "Reports",
    to: "/reports",
    icon: (
      <CIcon content={freeSet.cilNotes} customClasses="c-sidebar-nav-icon" />
    ),
    permission: "Permissions.Report.View",
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "Security",
    route: "/security",
    icon: (
      <CIcon
        content={freeSet.cilLockLocked}
        customClasses="c-sidebar-nav-icon"
      />
    ),
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "User Account",
        to: "/security/user-account",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Roles",
        to: "/security/user-roles",
        permission: "Permissions.Role.View",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Users",
        to: "/security/user-access",
        permission: "Permissions.User.View",
      },
      {
        _tag: "CSidebarNavItem",
        name: "System Settings",
        to: "/security/system-settings",
        permission: "Permissions.User.Edit",
      },
    ],
  },
];

export default _nav;
